module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n   " + _vm._s(_vm.actionToBePerformed) + "\n  ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/offering-manager/view"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create / Update Offering")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createOrUpdateOffering.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "legacy_name"
    }
  }, [_vm._v("Offering Name (internal)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.legacy_name),
      expression: "gRowObj.legacy_name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.legacy_name.required
    },
    attrs: {
      "type": "text",
      "id": "legacy_name",
      "placeholder": "Offering Name"
    },
    domProps: {
      "value": (_vm.gRowObj.legacy_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "legacy_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.legacy_name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter offering name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "snomed_code"
    }
  }, [_vm._v("Metadata (snomed code)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.snomed_code),
      expression: "gRowObj.snomed_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "snomed_code",
      "id": "name",
      "placeholder": "Snomed Code"
    },
    domProps: {
      "value": (_vm.gRowObj.snomed_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "snomed_code", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "short_name"
    }
  }, [_vm._v("Short Name (Code abbreviation)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.short_name),
      expression: "gRowObj.short_name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.short_name.required
    },
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Short Name"
    },
    domProps: {
      "value": (_vm.gRowObj.short_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "short_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.short_name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter short name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Offering Type")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.type.required
    },
    attrs: {
      "id": "type"
    },
    model: {
      value: (_vm.gRowObj.type),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "type", $$v)
      },
      expression: "gRowObj.type"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose an offering--")]), _vm._v(" "), _vm._l((_vm.offeringType), function(data) {
    return _c('option', {
      key: data.value,
      domProps: {
        "selected": data.value === _vm.gRowObj.type,
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.type.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an offering type.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "attributes"
    }
  }, [_vm._v("Offering Attributes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.attributes),
      expression: "gRowObj.attributes"
    }],
    key: _vm.invalidAttributes,
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && _vm.invalidAttributes
    },
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Offering attributes"
    },
    domProps: {
      "value": (_vm.gRowObj.attributes)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "attributes", $event.target.value)
      }, function($event) {
        return _vm.checkAttributes()
      }]
    }
  }), _vm._v(" "), (_vm.submitted && _vm.invalidAttributes) ? _c('span', {
    key: _vm.invalidAttributes,
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter valid JSON.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "short_name"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    on: {
      "change": function($event) {
        return _vm.getLanguagesInCountry()
      }
    },
    model: {
      value: (_vm.messageSet.country),
      callback: function($$v) {
        _vm.$set(_vm.messageSet, "country", $$v)
      },
      expression: "messageSet.country"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a country--")]), _vm._v(" "), _vm._l((_vm.countryList), function(data) {
    return _c('option', {
      key: data.country_id,
      domProps: {
        "selected": data.country_id === _vm.messageSet.country,
        "value": data.country_name
      }
    }, [_vm._v(_vm._s(data.country_name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    model: {
      value: (_vm.messageSet.language),
      callback: function($$v) {
        _vm.$set(_vm.messageSet, "language", $$v)
      },
      expression: "messageSet.language"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose language--")]), _vm._v(" "), _vm._l((_vm.languages), function(value, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": value.alias
      }
    }, [_vm._v("\n                                    " + _vm._s(value.name))])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-6 col-xs-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageSet.message),
      expression: "messageSet.message"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "message"
    },
    domProps: {
      "value": (_vm.messageSet.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.messageSet, "message", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-1 col-md-1 col-lg-1"
  }, [_c('label', {
    attrs: {
      "for": "property"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle add-property",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.addMessageSet()
      }
    }
  })])])]), _vm._v(" "), (Object.keys(_vm.messages).length) ? _c('table', {
    staticClass: "table table-striped margin-top-20"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.messages), function(value, key) {
    return _c('tbody', {
      key: key
    }, _vm._l((value), function(messageRow, language, iSub) {
      return _c('tr', {
        key: language
      }, [(iSub === 0) ? _c('td', {
        staticStyle: {
          "width": "10%",
          "background-color": "#e8e8e8"
        },
        attrs: {
          "rowspan": Object.keys(value).length
        }
      }, [_c('h4', [_c('strong', [_vm._v(_vm._s(key))])])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "7%",
          "background-color": "#f3f2f2"
        }
      }, [_c('strong', [_c('h4', [_vm._v(_vm._s(language))])])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "71%"
        }
      }, [_vm._v(_vm._s(messageRow))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_c('i', {
        staticClass: "fa fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            return _vm.editTranslation(language, key)
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_c('i', {
        staticClass: "fa fa-times-circle",
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            return _vm.deleteTranslation(value, language, key)
          }
        }
      })])])
    }), 0)
  })], 2) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])])])])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Offering Configuration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Display Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "width-100"
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
    staticClass: "width-100"
  }, [_vm._v("Language")]), _vm._v(" "), _c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4b5bd8e8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offerings/createOrUpdateOffering.vue
// module id = +Dgd
// module chunks = 1